<template>
  <ion-page>
    <ion-content class="h-full">
      <round-header
        image-type="component"
        :image="Book"
        title="Courses"
        disable-edit-mode="true"
      ></round-header>
      <div id="container">
        <div class="flex flex-wrap justify-center">
          <template v-for="course in courses">
            <course-button
              v-on:click="router.push('/courses/' + course.id)"
              :image="course.image"
              class="m-4 bg-gradient-to-t from-blue-300 to-blue-100"
              :label="course.name"
            />
          </template>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts" async>
import { IonContent, IonPage } from '@ionic/vue';
import { Book } from 'lucide-vue-next';
import RoundHeader from '../components/RoundHeader.vue';
import router from '../router';
import { directus } from '../services/Directus.ts';
import { readItems } from '@directus/sdk';
import { onMounted, ref, type Ref } from 'vue';
import CourseButton from '../components/CourseButton.vue';

const courses: Ref<any[]> = ref([]);

onMounted(async () => {
  courses.value = await directus.request(
    readItems('courses', {
      fields: ['id', 'name', 'image'],
    })
  );
});
</script>
